import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import CustomerModule from './CustomerModule.vue'
import ListCustomers from './views/ListCustomers.vue'
import CreateCustomer from './views/CreateCustomer.vue'
import ShowCustomer from './views/ShowCustomer.vue'
import EditCustomer from './views/EditCustomer.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/customers',
    component: CustomerModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListCustomers',
        component: ListCustomers,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateCustomer',
        component: CreateCustomer,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowCustomer',
        component: ShowCustomer,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id/edit',
        name: 'EditCustomer',
        component: EditCustomer,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
